import { of } from 'rxjs';

export class GqlServiceMockSpec {
    query() {
        of({});
    }

    mutation() {
        of({});
    }
}
